import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Accordion, Card, Button } from 'react-bootstrap';
import { actionCreators } from '../actions/globalAction';
import { Loader } from '../components/solar/Loader';
import { pvFinalBill } from '../components/objects/pvFinalBill';

class PvFinalBillClass extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { currentItemId: [], PvFinalbillUI: [] };
    }

    toggle(id) {
        const currentItemId = [...this.state.currentItemId];

        const idx = currentItemId.indexOf(id);
        if (idx >= 0)
            currentItemId.splice(idx, 1);
        else
            currentItemId.push(id);

        this.setState({ currentItemId });
    }

    componentDidMount() {
        pvFinalBill.PvFinalBillClass.url = pvFinalBill.PvFinalBillClass.defaultSegment + "/pvfinal/";
        
        // This method runs when the component is first added to the page
        for (var k in pvFinalBill) {
            this.props.request(pvFinalBill[k]);
        }
    }


    render() {
        let PvFinalbillUI = this.props.PvFinalbillUI || {};

        return (
            <div>
                
                    
                            {
                    PvFinalbillUI.map((_data, index) =>
                                    <div>
                                        <Loader show={!this.props.isLoaded} />
                                        <Button variant="info" onClick={() => this.toggle(index)} style={{ width: '100%', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: _data.Headline }}></Button>
                                        <Accordion.Collapse in={this.state.currentItemId.includes(index)}>
                                            <Card className="mb-0">
                                                <Card.Body>
                                                    <div dangerouslySetInnerHTML={{ __html: _data.PanelContent }} />
                                                </Card.Body>
                                            </Card>
                                        </Accordion.Collapse>
                                    </div>)
                            }
                       
                    
                
            </div>
        );
    }

}

export default connect(
    state => state.pvfinalbillReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PvFinalBillClass);